import React from "react";
import { Dropdown, Nav, Toast } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
} from "../actions";
import Logo from "../assets/images/logo.svg";
import LogoWhite from "../assets/images/logo-white.svg";
import UserImage from "../assets/images/user.png";
import Avatar4 from "../assets/images/xs/avatar4.jpg";
import Avatar5 from "../assets/images/xs/avatar5.jpg";
import Avatar2 from "../assets/images/xs/avatar2.jpg";
import Avatar1 from "../assets/images/xs/avatar1.jpg";
import Avatar3 from "../assets/images/xs/avatar3.jpg";

class NavbarMenu extends React.Component {
  state = {
    linkupdate: false,
  };
  componentDidMount() {
    this.props.tostMessageLoad(true);
    const { activeKey } = this.props;
    this.activeMenutabwhenNavigate("/" + activeKey);
  }

  activeMenutabwhenNavigate(activeKey) {
    if (
      activeKey === "/dashboard" ||
      activeKey === "/demographic" ||
      activeKey === "/ioT"
    ) {
      this.activeMenutabContainer("dashboradContainer");
    } else if (
      activeKey === "/appinbox" ||
      activeKey === "/appchat" ||
      activeKey === "/appcalendar" ||
      activeKey === "/appcontact" ||
      activeKey === "/apptaskbar"
    ) {
      this.activeMenutabContainer("AppContainer");
    } else if (
      activeKey === "/filemanagerdashboard" ||
      activeKey === "/filedocuments" ||
      activeKey === "/filemedia"
    ) {
      this.activeMenutabContainer("FileManagerContainer");
    } else if (
      activeKey === "/blognewpost" ||
      activeKey === "/bloglist" ||
      activeKey === "/blogdetails"
    ) {
      this.activeMenutabContainer("BlogContainer");
    } else if (
      activeKey === "/uitypography" ||
      activeKey === "/uitabs" ||
      activeKey === "/uibuttons" ||
      activeKey === "/bootstrapui" ||
      activeKey === "/uiicons" ||
      activeKey === "/uinotifications" ||
      activeKey === "/uicolors" ||
      activeKey === "/uilistgroup" ||
      activeKey === "/uimediaobject" ||
      activeKey === "/uimodal" ||
      activeKey === "/uiprogressbar"
    ) {
      this.activeMenutabContainer("UIElementsContainer");
    } else if (
      activeKey === "/widgetsdata" ||
      activeKey === "/widgetsweather" ||
      activeKey === "/widgetsblog" ||
      activeKey === "/widgetsecommers"
    ) {
      this.activeMenutabContainer("WidgetsContainer");
    } else if (activeKey === "/login") {
      this.activeMenutabContainer("WidgetsContainer");
    } else if (
      activeKey === "/teamsboard" ||
      activeKey === "/profilev2page" ||
      activeKey === "/helperclass" ||
      activeKey === "/searchresult" ||
      activeKey === "/invoicesv2" ||
      activeKey === "/invoices" ||
      activeKey === "/pricing" ||
      activeKey === "/timeline" ||
      activeKey === "/profilev1page" ||
      activeKey === "/blankpage" ||
      activeKey === "/imagegalleryprofile" ||
      activeKey === "/projectslist" ||
      activeKey === "/maintanance" ||
      activeKey === "/testimonials" ||
      activeKey === "/faqs"
    ) {
      this.activeMenutabContainer("PagesContainer");
    } else if (
      activeKey === "/formvalidation" ||
      activeKey === "/basicelements"
    ) {
      this.activeMenutabContainer("FormsContainer");
    } else if (activeKey === "/tablenormal") {
      this.activeMenutabContainer("TablesContainer");
    } else if (activeKey === "/echart") {
      this.activeMenutabContainer("chartsContainer");
    } else if (activeKey === "/leafletmap") {
      this.activeMenutabContainer("MapsContainer");
    }
  }

  // componentWillReceiveProps(){
  //   this.setState({
  //     linkupdate:!this.state.linkupdate
  //   })
  // }

   handleLogout (){
    localStorage.removeItem("authToken")
   }

  activeMenutabContainer(id) {
    var parents = document.getElementById("main-menu");
    var activeMenu = document.getElementById(id);

    for (let index = 0; index < parents.children.length; index++) {
      if (parents.children[index].id !== id) {
        parents.children[index].classList.remove("active");
        parents.children[index].children[1].classList.remove("in");
      }
    }
    setTimeout(() => {
      activeMenu.classList.toggle("active");
      activeMenu.children[1].classList.toggle("in");
    }, 10);
  }
  render() {
    const {
      addClassactive,
      addClassactiveChildAuth,
      addClassactiveChildMaps,
      themeColor,
      toggleNotification,
      toggleEqualizer,
      sideMenuTab,
      isToastMessage,
      activeKey,
    } = this.props;
    document.body.classList.add(themeColor);

    return (
      <div>
        {isToastMessage ? (
          <Toast
            id="toast-container"
            show={isToastMessage}
            onClose={() => {
              this.props.tostMessageLoad(false);
            }}
            className="toast-info toast-top-right"
            autohide={true}
            delay={5000}
          >
            <Toast.Header className="toast-info mb-0">
              Hello, welcome to Lucid, a unique admin Template.
            </Toast.Header>
          </Toast>
        ) : null}
           <nav className="navbar navbar-fixed-top">
          <div className="container-fluid">
            <div className="navbar-btn">
              <button
                className="btn-toggle-offcanvas"
                onClick={() => {
                  this.props.onPressSideMenuToggle();
                }}
              >
                <i className="lnr lnr-menu fa fa-bars"></i>
              </button>
            </div>

            <div className="navbar-brand">
              <a href="dashboard">
           MY SHOPIO ADMIN
                {/* <img
                  src={
                    document.body.classList.contains("full-dark")
                      ? LogoWhite
                      : Logo
                  }
                  alt="Lucid Logo"
                  className="img-responsive logo"
                /> */}
              </a>
            </div>

            <div className="navbar-right">
                     {/* <form id="navbar-search" className="navbar-form search-form">
                <input
                  className="form-control"
                  placeholder="Search here..."
                  type="text"
                />
                <button type="button" className="btn btn-default">
                  <i className="icon-magnifier"></i>
                </button>
              </form> */}

              <div id="navbar-menu">
                <ul className="nav navbar-nav">
                    {/* <li>
                      <a
                        href="filedocuments"
                        className="icon-menu d-none d-sm-block d-md-none d-lg-block"
                      >
                        <i className="fa fa-folder-open-o"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="appcalendar"
                        className="icon-menu d-none d-sm-block d-md-none d-lg-block"
                      >
                        <i className="icon-calendar"></i>
                      </a>
                    </li>
                    <li>
                      <a href="appchat" className="icon-menu d-none d-sm-block">
                        <i className="icon-bubbles"></i>
                      </a>
                    </li>
                    <li>
                      <a href="appinbox" className="icon-menu d-none d-sm-block">
                        <i className="icon-envelope"></i>
                        <span className="notification-dot"></span>
                      </a>
                    </li>
                    <li
                      className={
                        toggleNotification ? "show dropdown" : "dropdown"
                      }
                    >
                      <a
                        href="#!"
                        className="dropdown-toggle icon-menu"
                        data-toggle="dropdown"
                        onClick={(e) => {
                                e.preventDefault();
                          this.props.onPressNotification();
                        }}
                      >
                        <i className="icon-bell"></i>
                        <span className="notification-dot"></span>
                      </a>
                      <ul
                        className={
                          toggleNotification
                            ? "dropdown-menu notifications show"
                            : "dropdown-menu notifications"
                        }
                      >
                        <li className="header">
                          <strong>You have 4 new Notifications</strong>
                        </li>
                        <li>
                          <Link to="#">
                            <div className="media">
                              <div className="media-left">
                                <i className="icon-info text-warning"></i>
                              </div>
                              <div className="media-body">
                                <p className="text">
                                  Campaign <strong>Holiday Sale</strong> is nearly
                                  reach budget limit.
                                </p>
                                <span className="timestamp">10:00 AM Today</span>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <div className="media">
                              <div className="media-left">
                                <i className="icon-like text-success"></i>
                              </div>
                              <div className="media-body">
                                <p className="text">
                                  Your New Campaign <strong>Holiday Sale</strong>{" "}
                                  is approved.
                                </p>
                                <span className="timestamp">11:30 AM Today</span>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <div className="media">
                              <div className="media-left">
                                <i className="icon-pie-chart text-info"></i>
                              </div>
                              <div className="media-body">
                                <p className="text">
                                  Website visits from Twitter is 27% higher than
                                  last week.
                                </p>
                                <span className="timestamp">04:00 PM Today</span>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <div className="media">
                              <div className="media-left">
                                <i className="icon-info text-danger"></i>
                              </div>
                              <div className="media-body">
                                <p className="text">
                                  Error on website analytics configurations
                                </p>
                                <span className="timestamp">Yesterday</span>
                              </div>
                            </div>
                          </Link>
                        </li>
                        <li className="footer">
                          <Link to="#" className="more">See all notifications</Link>
                        </li>
                      </ul>
                    </li>
                    <li
                      className={toggleEqualizer ? "show dropdown" : "dropdown"}
                    >
                      <a
                        href="#!"
                        className="dropdown-toggle icon-menu"
                        data-toggle="dropdown"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.onPressEqualizer();
                        }}
                      >
                        <i className="icon-equalizer"></i>
                      </a>
                      <ul
                        className={
                          toggleEqualizer
                            ? "dropdown-menu user-menu menu-icon show"
                            : "dropdown-menu user-menu menu-icon"
                        }
                      >
                        <li className="menu-heading">ACCOUNT SETTINGS</li>
                        <li>
                          <Link to="#">
                            <i className="icon-note"></i> <span>Basic</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="icon-equalizer"></i>{" "}
                            <span>Preferences</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="icon-lock"></i> <span>Privacy</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="icon-bell"></i>{" "}
                            <span>Notifications</span>
                          </Link>
                        </li>
                        <li className="menu-heading">BILLING</li>
                        <li>
                          <Link to="#">
                            <i className="icon-credit-card"></i>{" "}
                            <span>Payments</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="icon-printer"></i> <span>Invoices</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="icon-refresh"></i> <span>Renewals</span>
                          </Link>
                        </li>
                      </ul>
                    </li> */}
                  <li>
                    <Link to = "/login"className="icon-menu" onClick={this.handleLogout}>
                     Logout <i className="icon-login"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>

        <div id="left-sidebar" className="sidebar" style={{ zIndex: 9 }}>
          <div className="sidebar-scroll">
            <div className="user-account">
              <img
                src={UserImage}
                className="rounded-circle user-photo"
                alt="User Profile"
              />
              <Dropdown>
                <span>Welcome,</span>
                <Dropdown.Toggle
                  variant="none"
                  as="a"
                  id="dropdown-basic"
                  className="user-name"
                >
                  <strong>Admin</strong>
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu-right account">
                  <Dropdown.Item href="profilev2page">
                    <i className="icon-user"></i>My Profile
                  </Dropdown.Item>
                  <Dropdown.Item href="appinbox">
                    {" "}
                    <i className="icon-envelope-open"></i>Messages
                  </Dropdown.Item>
                  <Dropdown.Item>
                    {" "}
                    <i className="icon-settings"></i>Settings
                  </Dropdown.Item>
                  <li className="divider"></li>
                  <Dropdown.Item href="login">
                    {" "}
                    <i className="icon-power"></i>Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {/* <hr />
              <ul className="row list-unstyled">
                <li className="col-4">
                  <small>Sales</small>
                  <h6>456</h6>
                </li>
                <li className="col-4">
                  <small>Order</small>
                  <h6>1350</h6>
                </li>
                <li className="col-4">
                  <small>Revenue</small>
                  <h6>$2.13B</h6>
                </li>
              </ul> */}
            </div>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <Link
                  to="#"
                  className={sideMenuTab[0] ? "nav-link active" : "nav-link"}
                  data-toggle="tab"
                  onClick={() => {
                    this.props.onPressSideMenuTab(0);
                  }}
                >
                  Menu
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="#"
                  className={sideMenuTab[1] ? "nav-link active" : "nav-link"}
                  data-toggle="tab"
                  onClick={() => {
                    this.props.onPressSideMenuTab(1);
                  }}
                >
                  <i className="icon-book-open"></i>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="#"
                  className={sideMenuTab[2] ? "nav-link active" : "nav-link"}
                  data-toggle="tab"
                  onClick={() => {
                    this.props.onPressSideMenuTab(2);
                  }}
                >
                  <i className="icon-settings"></i>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="#"
                  className={sideMenuTab[3] ? "nav-link active" : "nav-link"}
                  data-toggle="tab"
                  onClick={() => {
                    this.props.onPressSideMenuTab(3);
                  }}
                >
                  <i className="icon-question"></i>
                </Link>
              </li>
            </ul>
            <div className="tab-content p-l-0 p-r-0">
              <div
                className={sideMenuTab[0] ? "tab-pane active show" : "tab-pane"}
                id="menu"
              >
                <Nav id="left-sidebar-nav" className="sidebar-nav">
                  <ul id="main-menu" className="metismenu">
                    <li className="" id="dashboradContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("dashboradContainer");
                        }}
                      >
                        <i className="icon-home"></i> <span>Dashboard</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "dashboard" ? "active" : ""}
                        >
                          <Link to="dashboard">Overview</Link>
                        </li>
                        {/* <li
                          className={
                            activeKey === "demographic" ? "active" : ""
                          }
                        >
                          <Link to="demographic">Demographic</Link>
                        </li> */}
                        {/* <li className={activeKey === "ioT" ? "active" : ""}>
                          <Link to="ioT">IoT</Link>
                        </li> */}
                      </ul>
                    </li>
                    <li className="" id="registerContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("registerContainer");
                        }}
                      >
                      <i className="icon-users"></i> <span>Users</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "formregister" ? "active" : ""}
                        >
                          <Link to="formregister">Add Users</Link>
                        </li>
                        <li
                          className={activeKey === "list" ? "active" : ""}
                        >
                          <Link to="list">List</Link>
                        </li>
                      </ul>
                    </li>
                    {/* <li className="" id="deliveryboyContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("deliveryboyContainer");
                        }}
                      >
                        <i className="icon-envelope"></i>  <span>Merchant</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "add-marchant" ? "active" : ""}
                        >
                          <Link to="add-marchant">Add</Link>
                        </li>
                        <li
                          className={activeKey === "list-marchant" ? "active" : ""}
                        >
                          <Link to="list-marchant">List</Link>
                        </li>
                      </ul>
                    </li> */}
                    {/* <li className="" id="ordersContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("ordersContainer");
                        }}
                      >
                        <i className="icon-home"></i> <span>Orders</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "order-list-all" ? "active" : ""}
                        >
                          <Link to="order-list-all">All Order List</Link>
                        </li>
                        
                      </ul>
                    </li> */}
                 
                    <li className="" id="brandsContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("brandsContainer");
                        }}
                      >
                        <i className="icon-bag"></i><span>Stores</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "add-brands" ? "active" : ""}
                        >
                          <Link to="add-brands">Add </Link>
                        </li>
                        <li
                          className={activeKey === "list-brands" ? "active" : ""}
                        >
                          <Link to="list-brands">List </Link>
                        </li>
                        {/* <li
                          className={activeKey === "add-attribute" ? "active" : ""}
                        >
                          <Link to="add-attribute">Add Attribute</Link>
                        </li>
                        <li
                          className={activeKey === "list-attribute" ? "active" : ""}
                        >
                          <Link to="list-attribute">List Attribute</Link>
                        </li> */}
                      </ul>
                    </li>
                    <li className="" id="brandsNewContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("brandsNewContainer");
                        }}
                      >
                        <i className="icon-bag"></i><span>Brands</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "add-brandsNew" ? "active" : ""}
                        >
                          <Link to="add-brandsNew">Add </Link>
                        </li>
                        <li
                          className={activeKey === "list-brandsNew" ? "active" : ""}
                        >
                          <Link to="list-brandsNew">List </Link>
                        </li>
                       
                      </ul>
                    </li>
                    <li className="" id="productCategoryContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("productCategoryContainer");
                        }}
                      >
                            <i className="icon-screen-tablet"></i>  <span>Product Category</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "add-product-category" ? "active" : ""}
                        >
                          <Link to="add-product-category">Add Product Category</Link>
                        </li>
                        <li
                          className={activeKey === "list-product-category" ? "active" : ""}
                        >
                          <Link to="list-product-category">List Product Category</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="" id="dealsContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("dealsContainer");
                        }}
                      >
                        <i className="icon-basket"></i> <span>Deals</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "add-deals" ? "active" : ""}
                        >
                          <Link to="add-deals">Add</Link>
                        </li>
                        <li
                          className={activeKey === "list-deals" ? "active" : ""}
                        >
                          <Link to="list-deals">List</Link>
                        </li>
                       
                      </ul>
                    </li>
                    {/* <li className="" id="productCategorySubContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("productCategorySubContainer");
                        }}
                      >
                       <i className="icon-screen-smartphone"></i> <span>Product Sub Category</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "add-product-sub-category" ? "active" : ""}
                        >
                          <Link to="add-product-sub-category">Add Product Sub Category</Link>
                        </li>
                        <li
                          className={activeKey === "list-product-sub-category" ? "active" : ""}
                        >
                          <Link to="list-product-sub-category">List Product Sub Category</Link>
                        </li>
                      </ul>
                    </li> */}
              
                    {/* <li className="" id="couponsContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("couponsContainer");
                        }}
                      >
                        <i className="icon-home"></i> <span>Coupons</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "add-coupons" ? "active" : ""}
                        >
                          <Link to="add-coupons">Add Coupons</Link>
                        </li>
                        <li
                          className={activeKey === "list-coupons" ? "active" : ""}
                        >
                          <Link to="list-coupons">List Coupons</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="" id="locationContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("locationContainer");
                        }}
                      >
                        <i className="icon-home"></i> <span>Location</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "add-location" ? "active" : ""}
                        >
                          <Link to="add-location">Add Location</Link>
                        </li>
                        <li
                          className={activeKey === "list-location" ? "active" : ""}
                        >
                          <Link to="list-location">List Location</Link>
                        </li>
                      </ul>
                    </li> */}
                    <li className="" id="packagesContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("packagesContainer");
                        }}
                      >
                         <i className="icon-plane"></i> <span>Packages</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "add-packages" ? "active" : ""}
                        >
                          <Link to="add-packages">Add Packages</Link>
                        </li>
                        <li
                          className={activeKey === "list-packages" ? "active" : ""}
                        >
                          <Link to="list-packages">List Packages</Link>
                        </li>
                      </ul>
                    </li>
                    
                    {/* <li className="" id="payoutContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("payoutContainer");
                        }}
                      >
                        <i className="icon-home"></i> <span>Payout</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "payout-list" ? "active" : ""}
                        >
                          <Link to="payout-list">Wholesaler Payout List</Link>
                        </li>
                        
                      </ul>
                    </li>
                    <li className="" id="medicineContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("medicineContainer");
                        }}
                      >
                        <i className="icon-home"></i> <span>Expiry Medicine</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "medicine-list" ? "active" : ""}
                        >
                          <Link to="medicine-list">Expiry Medicine List</Link>
                        </li>
                       
                      </ul>
                    </li>
                    <li className="" id="reportContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("reportContainer");
                        }}
                      >
                        <i className="icon-home"></i> <span>Manage Report</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "sales-list" ? "active" : ""}
                        >
                          <Link to="sales-list">Sales & Transaction Report</Link>
                        </li>
                        <li
                          className={activeKey === "earnings-list" ? "active" : ""}
                        >
                          <Link to="earnings-list">Earnings Report</Link>
                        </li>
                        <li
                          className={activeKey === "vendor-sales-list" ? "active" : ""}
                        >
                          <Link to="vendor-sales-list">Vendor Sales Report</Link>
                        </li>
                        <li
                          className={activeKey === "transaction-list" ? "active" : ""}
                        >
                          <Link to="transaction-list">Transaction Report</Link>
                        </li>
                        <li
                          className={activeKey === "package-list" ? "active" : ""}
                        >
                          <Link to="package-list">Package Report</Link>
                        </li>
                      </ul>
                    </li> */}
                    <li id="TablesContainerBanner" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("TablesContainerBanner");
                        }}
                      >
                        <i className="icon-tag"></i> <span>Top Banners</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={
                            activeKey === "topbannerlist" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="topbannerlist">List</Link>{" "}
                        </li>
                        <li
                          className={
                            activeKey === "addtopbanner" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="addtopbanner">Add</Link>{" "}
                        </li>
                  
                       
                      </ul>
                    </li>
                    <li id="TablesContainerCenterBanner" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("TablesContainerCenterBanner");
                        }}
                      >
                        <i className="icon-tag"></i> <span>Center Banners</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={
                            activeKey === "centerbannerlist" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="centerbannerlist">List</Link>{" "}
                        </li>
                        <li
                          className={
                            activeKey === "addcenterbanner" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="addcenterbanner">Add</Link>{" "}
                        </li>
                  
                       
                      </ul>
                    </li>
                    <li id="TablesContainerBottomBanner" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("TablesContainerBottomBanner");
                        }}
                      >
                        <i className="icon-tag"></i> <span>Bottom Banners</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={
                            activeKey === "bottombannerlist" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="bottombannerlist">List</Link>{" "}
                        </li>
                        <li
                          className={
                            activeKey === "addbottombanner" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="addbottombanner">Add</Link>{" "}
                        </li>
                  
                       
                      </ul>
                    </li>
                    {/* <li id="FileManagerContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("FileManagerContainer");
                        }}
                      >
                        <i className="icon-folder"></i>{" "}
                        <span>File Manager</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={
                            activeKey === "filemanagerdashboard" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="filemanagerdashboard">Dashboard</Link>
                        </li>
                        <li
                          className={
                            activeKey === "filedocuments" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="filedocuments">Documents</Link>
                        </li>
                        <li
                          className={activeKey === "filemedia" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="filemedia">Media</Link>
                        </li>
                        <li
                          className={activeKey === "fileimages" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="fileimages">Images</Link>
                        </li>
                      </ul>
                    </li>
                    <li id="BlogContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("BlogContainer");
                        }}
                      >
                        <i className="icon-globe"></i> <span>Blog</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={
                            activeKey === "blognewpost" ? "active" : ""
                          }
                        >
                          <Link to="blognewpost">New Post</Link>
                        </li>
                        <li
                          className={activeKey === "bloglist" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="bloglist">Blog List</Link>
                        </li>
                        <li
                          className={
                            activeKey === "blogdetails" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="blogdetails">Blog Detail</Link>
                        </li>
                      </ul>
                    </li>
                    <li id="UIElementsContainer" className="">
                      <a
                        href="#uiElements"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("UIElementsContainer");
                        }}
                      >
                        <i className="icon-diamond"></i>{" "}
                        <span>UI Elements</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={
                            activeKey === "uitypography" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="uitypography">Typography</Link>
                        </li>
                        <li
                          className={activeKey === "uitabs" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="uitabs">Tabs</Link>
                        </li>
                        <li
                          className={activeKey === "uibuttons" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="uibuttons">Buttons</Link>
                        </li>
                        <li
                          className={
                            activeKey === "bootstrapui" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="bootstrapui">Bootstrap UI</Link>
                        </li>
                        <li
                          className={activeKey === "uiicons" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="uiicons">Icons</Link>
                        </li>
                        <li
                          className={
                            activeKey === "uinotifications" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="uinotifications">Notifications</Link>
                        </li>
                        <li
                          className={activeKey === "uicolors" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="uicolors">Colors</Link>
                        </li>

                        <li
                          className={
                            activeKey === "uilistgroup" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="uilistgroup">List Group</Link>
                        </li>
                        <li
                          className={
                            activeKey === "uimediaobject" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="uimediaobject">Media Object</Link>
                        </li>
                        <li
                          className={activeKey === "uimodal" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="uimodal">Modals</Link>
                        </li>
                        <li
                          className={
                            activeKey === "uiprogressbar" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="uiprogressbar">Progress Bars</Link>
                        </li>
                      </ul>
                    </li>
                    <li id="WidgetsContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("WidgetsContainer");
                        }}
                      >
                        <i className="icon-puzzle"></i> <span>Widgets</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={
                            activeKey === "widgetsdata" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="widgetsdata">Data</Link>
                        </li>

                        <li
                          className={
                            activeKey === "widgetsweather" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="widgetsweather">Weather</Link>
                        </li>

                        <li
                          className={
                            activeKey === "widgetsblog" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="widgetsblog">Blog</Link>
                        </li>
                        <li
                          className={
                            activeKey === "widgetsecommers" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="widgetsecommers">eCommerce</Link>
                        </li>
                      </ul>
                    </li>
                    <li id="AuthenticationContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer(
                            "AuthenticationContainer"
                          );
                        }}
                      >
                        <i className="icon-lock"></i>{" "}
                        <span>Authentication</span>
                      </a>
                      <ul
                        className={
                          addClassactive[6] ? "collapse in" : "collapse"
                        }
                      >
                        <li
                          className={addClassactiveChildAuth[0] ? "active" : ""}
                        >
                          <a href="login">Login</a>
                        </li>
                        <li
                          className={addClassactiveChildAuth[1] ? "active" : ""}
                        >
                          <a href="registration">Register</a>
                        </li>
                        <li
                          className={addClassactiveChildAuth[2] ? "active" : ""}
                        >
                          <a href="lockscreen">Lockscreen</a>
                        </li>
                        <li
                          className={addClassactiveChildAuth[3] ? "active" : ""}
                        >
                          <a href="forgotpassword">Forgot Password</a>
                        </li>
                        <li
                          className={addClassactiveChildAuth[4] ? "active" : ""}
                        >
                          <a href="page404">Page 404</a>
                        </li>
                        <li
                          className={addClassactiveChildAuth[5] ? "active" : ""}
                        >
                          <a href="page403">Page 403</a>
                        </li>
                        <li
                          className={addClassactiveChildAuth[6] ? "active" : ""}
                        >
                          <a href="page500">Page 500</a>
                        </li>
                        <li
                          className={addClassactiveChildAuth[7] ? "active" : ""}
                        >
                          <a href="page503">Page 503</a>
                        </li>
                      </ul>
                    </li>
                    <li id="PagesContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("PagesContainer");
                        }}
                      >
                        <i className="icon-docs"></i> <span>Pages</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "blankpage" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="blankpage">Blank Page</Link>{" "}
                        </li>
                        <li
                          className={
                            activeKey === "profilev1page" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="profilev1page">
                            Profile{" "}
                            <span className="badge badge-default float-right">
                              v1
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            activeKey === "profilev2page" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="profilev2page">
                            Profile{" "}
                            <span className="badge badge-warning float-right">
                              v2
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            activeKey === "imagegalleryprofile" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="imagegalleryprofile">Image Gallery </Link>{" "}
                        </li>

                        <li
                          className={activeKey === "timeline" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="timeline">Timeline</Link>
                        </li>

                        <li
                          className={activeKey === "pricing" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="pricing">Pricing</Link>
                        </li>
                        <li
                          className={activeKey === "invoices" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="invoices">
                            Invoices
                            <span className="badge badge-default float-right">
                              v1
                            </span>
                          </Link>
                        </li>
                        <li
                          className={activeKey === "invoicesv2" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="invoicesv2">
                            Invoices{" "}
                            <span className="badge badge-warning float-right">
                              v2
                            </span>
                          </Link>
                        </li>
                        <li
                          className={
                            activeKey === "searchresult" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="searchresult">Search Results</Link>
                        </li>
                        <li
                          className={
                            activeKey === "helperclass" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="helperclass">Helper Classes</Link>
                        </li>
                        <li
                          className={activeKey === "teamsboard" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="teamsboard">Teams Board</Link>
                        </li>
                        <li
                          className={
                            activeKey === "projectslist" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="projectslist">Projects List</Link>
                        </li>
                        <li
                          className={
                            activeKey === "maintanance" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="maintanance">Maintenance</Link>
                        </li>
                        <li
                          className={
                            activeKey === "testimonials" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="testimonials">Testimonials</Link>
                        </li>
                        <li
                          className={activeKey === "faqs" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="faqs">FAQ</Link>
                        </li>
                      </ul>
                    </li>
                    <li id="FormsContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("FormsContainer");
                        }}
                      >
                        <i className="icon-pencil"></i> <span>Forms</span>
                      </a>
                      <ul className={"collapse"}>
                        <li
                          className={
                            activeKey === "formvalidation" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="formvalidation">Form Validation</Link>
                        </li>
                        <li
                          className={
                            activeKey === "basicelements" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="basicelements">Basic Elements</Link>
                        </li>
                      </ul>
                    </li>
                    <li id="TablesContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("TablesContainer");
                        }}
                      >
                        <i className="icon-tag"></i> <span>Tables</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={
                            activeKey === "tablenormal" ? "active" : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="tablenormal">Normal Tables</Link>{" "}
                        </li>
                      </ul>
                    </li>
                    <li id="chartsContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("chartsContainer");
                        }}
                      >
                        <i className="icon-bar-chart"></i> <span>Charts</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={activeKey === "echart" ? "active" : ""}
                          onClick={() => {}}
                        >
                          <Link to="echart">E-chart</Link>{" "}
                        </li>
                      </ul>
                    </li>
                    <li id="MapsContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          this.activeMenutabContainer("MapsContainer");
                        }}
                      >
                        <i className="icon-map"></i> <span>Maps</span>
                      </a>
                      <ul className="collapse">
                        <li
                          className={
                            activeKey === "leafletmap" ||
                            addClassactiveChildMaps[0]
                              ? "active"
                              : ""
                          }
                          onClick={() => {}}
                        >
                          <Link to="leafletmap">Leaflet Map</Link>
                        </li>
                      </ul>
                    </li> */}
                  </ul>
                </Nav>
              </div>
              <div
                className={
                  sideMenuTab[1]
                    ? "tab-pane p-l-15 p-r-15 show active"
                    : "tab-pane p-l-15 p-r-15"
                }
                id="Chat"
              >
                <form>
                  <div className="input-group m-b-20">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className="icon-magnifier"></i>
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                    />
                  </div>
                </form>
                <ul className="right_chat list-unstyled">
                  <li className="online">
                    <Link to="#">
                      <div className="media">
                        <img className="media-object " src={Avatar4} alt="" />
                        <div className="media-body">
                          <span className="name">Chris Fox</span>
                          <span className="message">Designer, Blogger</span>
                          <span className="badge badge-outline status"></span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="online">
                    <Link to="#">
                      <div className="media">
                        <img className="media-object " src={Avatar5} alt="" />
                        <div className="media-body">
                          <span className="name">Joge Lucky</span>
                          <span className="message">Java Developer</span>
                          <span className="badge badge-outline status"></span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="offline">
                    <Link to="#">
                      <div className="media">
                        <img className="media-object " src={Avatar2} alt="" />
                        <div className="media-body">
                          <span className="name">Isabella</span>
                          <span className="message">CEO, Thememakker</span>
                          <span className="badge badge-outline status"></span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="offline">
                    <Link to="#">
                      <div className="media">
                        <img className="media-object " src={Avatar1} alt="" />
                        <div className="media-body">
                          <span className="name">Folisise Chosielie</span>
                          <span className="message">
                            Art director, Movie Cut
                          </span>
                          <span className="badge badge-outline status"></span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="online">
                    <Link to="#">
                      <div className="media">
                        <img className="media-object " src={Avatar3} alt="" />
                        <div className="media-body">
                          <span className="name">Alexander</span>
                          <span className="message">Writter, Mag Editor</span>
                          <span className="badge badge-outline status"></span>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div
                className={
                  sideMenuTab[2]
                    ? "tab-pane p-l-15 p-r-15 show active"
                    : "tab-pane p-l-15 p-r-15"
                }
                id="setting"
              >
                <h6>Choose Mode</h6>
                <ul className="choose-skin list-unstyled">
                  <li
                    data-theme="white"
                    className={
                      document.body.classList.contains("full-dark")
                        ? ""
                        : "active"
                    }
                    onClick={() => {
                      this.setState({ somethi: false });
                      document.body.classList.remove("full-dark");
                    }}
                  >
                    <div className="white"></div>
                    <span>Light</span>
                  </li>
                  <li
                    data-theme="black"
                    className={
                      document.body.classList.contains("full-dark")
                        ? "active"
                        : ""
                    }
                    onClick={() => {
                      this.setState({ somethi: true });
                      document.body.classList.add("full-dark");
                    }}
                  >
                    <div className="black"></div>
                    <span>Dark</span>
                  </li>
                </ul>
                <hr />
                <h6>Choose Skin</h6>
                <ul className="choose-skin list-unstyled">
                  <li
                    data-theme="purple"
                    className={themeColor === "theme-purple" ? "active" : ""}
                  >
                    <div
                      className="purple"
                      onClick={() => {
                        if (themeColor !== "theme-purple") {
                          document.body.classList.remove(themeColor);
                        }
                        this.props.onPressThemeColor("purple");
                      }}
                    ></div>
                    <span>Purple</span>
                  </li>
                  <li
                    data-theme="blue"
                    className={themeColor === "theme-blue" ? "active" : ""}
                  >
                    <div
                      className="blue"
                      onClick={() => {
                        if (themeColor !== "theme-blue") {
                          document.body.classList.remove(themeColor);
                        }
                        this.props.onPressThemeColor("blue");
                      }}
                    ></div>
                    <span>Blue</span>
                  </li>
                  <li
                    data-theme="cyan"
                    className={themeColor === "theme-cyan" ? "active" : ""}
                  >
                    <div
                      className="cyan"
                      onClick={() => {
                        if (themeColor !== "theme-cyan") {
                          document.body.classList.remove(themeColor);
                        }
                        this.props.onPressThemeColor("cyan");
                      }}
                    ></div>
                    <span>Cyan</span>
                  </li>
                  <li
                    data-theme="green"
                    className={themeColor === "theme-green" ? "active" : ""}
                  >
                    <div
                      className="green"
                      onClick={() => {
                        if (themeColor !== "theme-green") {
                          document.body.classList.remove(themeColor);
                        }
                        this.props.onPressThemeColor("green");
                      }}
                    ></div>
                    <span>Green</span>
                  </li>
                  <li
                    data-theme="orange"
                    className={themeColor === "theme-orange" ? "active" : ""}
                  >
                    <div
                      className="orange"
                      onClick={() => {
                        if (themeColor !== "theme-orange") {
                          document.body.classList.remove(themeColor);
                        }
                        this.props.onPressThemeColor("orange");
                      }}
                    ></div>
                    <span>Orange</span>
                  </li>
                  <li
                    data-theme="blush"
                    className={themeColor === "theme-blush" ? "active" : ""}
                  >
                    <div
                      className="blush"
                      onClick={() => {
                        if (themeColor !== "theme-blush") {
                          document.body.classList.remove(themeColor);
                        }
                        this.props.onPressThemeColor("blush");
                      }}
                    ></div>
                    <span>Blush</span>
                  </li>
                </ul>
                <hr />
                <h6>General Settings</h6>
                <ul className="setting-list list-unstyled">
                  <li>
                    <label className="fancy-checkbox">
                      <input type="checkbox" name="checkbox" />
                      <span>Report Panel Usag</span>
                    </label>
                  </li>
                  <li>
                    <label className="fancy-checkbox">
                      <input type="checkbox" name="checkbox" />
                      <span>Email Redirect</span>
                    </label>
                  </li>
                  <li>
                    <label className="fancy-checkbox">
                      <input type="checkbox" name="checkbox" />
                      <span>Notifications</span>
                    </label>
                  </li>
                  <li>
                    <label className="fancy-checkbox">
                      <input type="checkbox" name="checkbox" />
                      <span>Auto Updates</span>
                    </label>
                  </li>
                  <li>
                    <label className="fancy-checkbox">
                      <input type="checkbox" name="checkbox" />
                      <span>Offline</span>
                    </label>
                  </li>
                  <li>
                    <label className="fancy-checkbox">
                      <input type="checkbox" name="checkbox" />
                      <span>Location Permission</span>
                    </label>
                  </li>
                </ul>
              </div>
              <div
                className={
                  sideMenuTab[3]
                    ? "tab-pane p-l-15 p-r-15 show active"
                    : "tab-pane p-l-15 p-r-15"
                }
                id="question"
              >
                <form>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className="icon-magnifier"></i>
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                    />
                  </div>
                </form>
                <ul className="list-unstyled question">
                  <li className="menu-heading">HOW-TO</li>
                  <li>
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      How to Create Campaign
                    </a>
                  </li>
                  <li>
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      Boost Your Sales
                    </a>
                  </li>
                  <li>
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      Website Analytics
                    </a>
                  </li>
                  <li className="menu-heading">ACCOUNT</li>
                  <li>
                    <a
                      href="registration"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      Cearet New Account
                    </a>
                  </li>
                  <li>
                    <a
                      href="forgotpassword"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      Change Password?
                    </a>
                  </li>
                  <li>
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      Privacy &amp; Policy
                    </a>
                  </li>
                  <li className="menu-heading">BILLING</li>
                  <li>
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      Payment info
                    </a>
                  </li>
                  <li>
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      Auto-Renewal
                    </a>
                  </li>
                  <li className="menu-button m-t-30">
                    <a
                      href="#!"
                      className="btn btn-primary"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <i className="icon-question"></i> Need Help?
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NavbarMenu.propTypes = {
  addClassactive: PropTypes.array.isRequired,
  addClassactiveChild: PropTypes.array.isRequired,
  addClassactiveChildApp: PropTypes.array.isRequired,
  addClassactiveChildFM: PropTypes.array.isRequired,
  addClassactiveChildBlog: PropTypes.array.isRequired,
  addClassactiveChildUI: PropTypes.array.isRequired,
  addClassactiveChildWidgets: PropTypes.array.isRequired,
  addClassactiveChildAuth: PropTypes.array.isRequired,
  addClassactiveChildPages: PropTypes.array.isRequired,
  addClassactiveChildForms: PropTypes.array.isRequired,
  addClassactiveChildTables: PropTypes.array.isRequired,
  addClassactiveChildChart: PropTypes.array.isRequired,
  addClassactiveChildMaps: PropTypes.array.isRequired,
  themeColor: PropTypes.string.isRequired,
  generalSetting: PropTypes.array.isRequired,
  toggleNotification: PropTypes.bool.isRequired,
  toggleEqualizer: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ navigationReducer }) => {
  const {
    addClassactive,
    addClassactiveChild,
    addClassactiveChildApp,
    addClassactiveChildFM,
    addClassactiveChildBlog,
    addClassactiveChildUI,
    addClassactiveChildWidgets,
    addClassactiveChildAuth,
    addClassactiveChildPages,
    addClassactiveChildForms,
    addClassactiveChildTables,
    addClassactiveChildChart,
    addClassactiveChildMaps,
    themeColor,
    generalSetting,
    toggleNotification,
    toggleEqualizer,
    menuProfileDropdown,
    sideMenuTab,
    isToastMessage,
  } = navigationReducer;
  return {
    addClassactive,
    addClassactiveChild,
    addClassactiveChildApp,
    addClassactiveChildFM,
    addClassactiveChildBlog,
    addClassactiveChildUI,
    addClassactiveChildWidgets,
    addClassactiveChildAuth,
    addClassactiveChildPages,
    addClassactiveChildForms,
    addClassactiveChildTables,
    addClassactiveChildChart,
    addClassactiveChildMaps,
    themeColor,
    generalSetting,
    toggleNotification,
    toggleEqualizer,
    menuProfileDropdown,
    sideMenuTab,
    isToastMessage,
  };
};

export default connect(mapStateToProps, {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
})(NavbarMenu);
